import { Page } from "./Containers/Subscriptions/Model.js";
import { fold, empty, singleton, append, toArray, ofArray, tail, head, isEmpty } from "./fable_modules/fable-library.3.7.20/List.js";
import { Route_$007CQuery$007C_$007C, Route_$007CInt64$007C_$007C, Route_$007CInt$007C_$007C } from "./fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { RouterModule_urlSegments, RouterModule_nav } from "./fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { Page as Page_1 } from "./Containers/Invoicee/Model.js";
import { Page as Page_2 } from "./Containers/ClientSettings/Model.js";
import { Page as Page_3 } from "./Containers/ContractType/Model.js";
import { Page as Page_4 } from "./Containers/Contracts/View.js";
import { Page as Page_5 } from "./Containers/CustomerContract/Model.js";
import { Page as Page_6 } from "./DevTools/Base.js";
import { Page as Page_7 } from "./Admin/Base.js";
import { Page as Page_8 } from "./Containers/StatusAndWarnings/Model.js";
import { Page as Page_9 } from "./Containers/Reports/Model.js";
import { Page as Page_10 } from "./Containers/FileImport/Model.js";
import { Page as Page_11 } from "./Containers/Imports/Model.js";
import { Page as Page_12 } from "./Containers/Billing/Model.js";
import { Page as Page_13 } from "./Containers/NumberInventory/Model.js";
import { Page as Page_14 } from "./Model.js";
import { ValidatedUrlModule_value, UrlKind, ValidatedUrlModule_create } from "./HttpV2.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";

function parseSubscriptionUrl(_arg) {
    let pattern_matching_result, contractNr;
    if (!isEmpty(_arg)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(_arg));
        if (activePatternResult != null) {
            if (!isEmpty(tail(_arg))) {
                if (head(tail(_arg)) === "Overview") {
                    if (isEmpty(tail(tail(_arg)))) {
                        pattern_matching_result = 1;
                        contractNr = activePatternResult;
                    }
                    else {
                        pattern_matching_result = 2;
                    }
                }
                else {
                    pattern_matching_result = 2;
                }
            }
            else {
                pattern_matching_result = 1;
                contractNr = activePatternResult;
            }
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page(0);
        }
        case 1: {
            return new Page(1, contractNr);
        }
        case 2: {
            let pattern_matching_result_1, contractNr_1;
            if (!isEmpty(_arg)) {
                const activePatternResult_1 = Route_$007CInt$007C_$007C(head(_arg));
                if (activePatternResult_1 != null) {
                    if (!isEmpty(tail(_arg))) {
                        if (head(tail(_arg)) === "Fees") {
                            if (isEmpty(tail(tail(_arg)))) {
                                pattern_matching_result_1 = 0;
                                contractNr_1 = activePatternResult_1;
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new Page(2, contractNr_1);
                }
                case 1: {
                    let pattern_matching_result_2, contractNr_2;
                    if (!isEmpty(_arg)) {
                        const activePatternResult_2 = Route_$007CInt$007C_$007C(head(_arg));
                        if (activePatternResult_2 != null) {
                            if (!isEmpty(tail(_arg))) {
                                if (head(tail(_arg)) === "Attributes") {
                                    if (isEmpty(tail(tail(_arg)))) {
                                        pattern_matching_result_2 = 0;
                                        contractNr_2 = activePatternResult_2;
                                    }
                                    else {
                                        pattern_matching_result_2 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return new Page(3, contractNr_2);
                        }
                        case 1: {
                            let pattern_matching_result_3, contractNr_3;
                            if (!isEmpty(_arg)) {
                                const activePatternResult_3 = Route_$007CInt$007C_$007C(head(_arg));
                                if (activePatternResult_3 != null) {
                                    if (!isEmpty(tail(_arg))) {
                                        if (head(tail(_arg)) === "FrozenMonths") {
                                            if (isEmpty(tail(tail(_arg)))) {
                                                pattern_matching_result_3 = 0;
                                                contractNr_3 = activePatternResult_3;
                                            }
                                            else {
                                                pattern_matching_result_3 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_3 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_3 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_3 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_3 = 1;
                            }
                            switch (pattern_matching_result_3) {
                                case 0: {
                                    return new Page(4, contractNr_3);
                                }
                                case 1: {
                                    let pattern_matching_result_4, contractNr_4;
                                    if (!isEmpty(_arg)) {
                                        const activePatternResult_4 = Route_$007CInt$007C_$007C(head(_arg));
                                        if (activePatternResult_4 != null) {
                                            if (!isEmpty(tail(_arg))) {
                                                if (head(tail(_arg)) === "Telecom") {
                                                    if (isEmpty(tail(tail(_arg)))) {
                                                        pattern_matching_result_4 = 0;
                                                        contractNr_4 = activePatternResult_4;
                                                    }
                                                    else {
                                                        pattern_matching_result_4 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_4 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_4 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_4 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_4 = 1;
                                    }
                                    switch (pattern_matching_result_4) {
                                        case 0: {
                                            return new Page(5, contractNr_4);
                                        }
                                        case 1: {
                                            let pattern_matching_result_5, contractNr_5;
                                            if (!isEmpty(_arg)) {
                                                const activePatternResult_5 = Route_$007CInt$007C_$007C(head(_arg));
                                                if (activePatternResult_5 != null) {
                                                    if (!isEmpty(tail(_arg))) {
                                                        if (head(tail(_arg)) === "History") {
                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                pattern_matching_result_5 = 0;
                                                                contractNr_5 = activePatternResult_5;
                                                            }
                                                            else {
                                                                pattern_matching_result_5 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_5 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_5 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_5 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_5 = 1;
                                            }
                                            switch (pattern_matching_result_5) {
                                                case 0: {
                                                    return new Page(6, contractNr_5);
                                                }
                                                case 1: {
                                                    let pattern_matching_result_6, contractNr_6;
                                                    if (!isEmpty(_arg)) {
                                                        const activePatternResult_6 = Route_$007CInt$007C_$007C(head(_arg));
                                                        if (activePatternResult_6 != null) {
                                                            if (!isEmpty(tail(_arg))) {
                                                                if (head(tail(_arg)) === "Traffic") {
                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                        pattern_matching_result_6 = 0;
                                                                        contractNr_6 = activePatternResult_6;
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_6 = 1;
                                                                    }
                                                                }
                                                                else {
                                                                    pattern_matching_result_6 = 1;
                                                                }
                                                            }
                                                            else {
                                                                pattern_matching_result_6 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_6 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_6 = 1;
                                                    }
                                                    switch (pattern_matching_result_6) {
                                                        case 0: {
                                                            return new Page(7, contractNr_6);
                                                        }
                                                        case 1: {
                                                            let pattern_matching_result_7, contractNr_7;
                                                            if (!isEmpty(_arg)) {
                                                                const activePatternResult_7 = Route_$007CInt$007C_$007C(head(_arg));
                                                                if (activePatternResult_7 != null) {
                                                                    if (!isEmpty(tail(_arg))) {
                                                                        if (head(tail(_arg)) === "Subproduct") {
                                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                                pattern_matching_result_7 = 0;
                                                                                contractNr_7 = activePatternResult_7;
                                                                            }
                                                                            else {
                                                                                pattern_matching_result_7 = 1;
                                                                            }
                                                                        }
                                                                        else {
                                                                            pattern_matching_result_7 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_7 = 1;
                                                                    }
                                                                }
                                                                else {
                                                                    pattern_matching_result_7 = 1;
                                                                }
                                                            }
                                                            else {
                                                                pattern_matching_result_7 = 1;
                                                            }
                                                            switch (pattern_matching_result_7) {
                                                                case 0: {
                                                                    return new Page(8, contractNr_7);
                                                                }
                                                                case 1: {
                                                                    return new Page(9);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

function parseInvoiceeUrl(_arg) {
    let pattern_matching_result, invoiceeNr;
    if (!isEmpty(_arg)) {
        const activePatternResult = Route_$007CInt64$007C_$007C(head(_arg));
        if (activePatternResult != null) {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 0;
                invoiceeNr = activePatternResult;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            RouterModule_nav(ofArray(toArray(append(RouterModule_urlSegments(window.location.hash, 1), singleton("Subscriptions")))), 1, 1);
            return new Page_1(1, invoiceeNr, parseSubscriptionUrl(empty()));
        }
        case 1: {
            let pattern_matching_result_1, invoiceeNr_1;
            if (!isEmpty(_arg)) {
                const activePatternResult_1 = Route_$007CInt64$007C_$007C(head(_arg));
                if (activePatternResult_1 != null) {
                    if (!isEmpty(tail(_arg))) {
                        if (head(tail(_arg)) === "Details") {
                            if (isEmpty(tail(tail(_arg)))) {
                                pattern_matching_result_1 = 0;
                                invoiceeNr_1 = activePatternResult_1;
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new Page_1(0, invoiceeNr_1);
                }
                case 1: {
                    let pattern_matching_result_2, invoiceeNr_2, subscriptionSubSegments;
                    if (!isEmpty(_arg)) {
                        const activePatternResult_2 = Route_$007CInt64$007C_$007C(head(_arg));
                        if (activePatternResult_2 != null) {
                            if (!isEmpty(tail(_arg))) {
                                if (head(tail(_arg)) === "Subscriptions") {
                                    pattern_matching_result_2 = 0;
                                    invoiceeNr_2 = activePatternResult_2;
                                    subscriptionSubSegments = tail(tail(_arg));
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return new Page_1(1, invoiceeNr_2, parseSubscriptionUrl(subscriptionSubSegments));
                        }
                        case 1: {
                            let pattern_matching_result_3, invoiceeNr_3;
                            if (!isEmpty(_arg)) {
                                const activePatternResult_3 = Route_$007CInt64$007C_$007C(head(_arg));
                                if (activePatternResult_3 != null) {
                                    if (!isEmpty(tail(_arg))) {
                                        if (head(tail(_arg)) === "Invoices") {
                                            pattern_matching_result_3 = 0;
                                            invoiceeNr_3 = activePatternResult_3;
                                        }
                                        else {
                                            pattern_matching_result_3 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_3 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_3 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_3 = 1;
                            }
                            switch (pattern_matching_result_3) {
                                case 0: {
                                    return new Page_1(2, invoiceeNr_3);
                                }
                                case 1: {
                                    let pattern_matching_result_4, invoiceeNr_4;
                                    if (!isEmpty(_arg)) {
                                        const activePatternResult_4 = Route_$007CInt64$007C_$007C(head(_arg));
                                        if (activePatternResult_4 != null) {
                                            if (!isEmpty(tail(_arg))) {
                                                if (head(tail(_arg)) === "Notes") {
                                                    if (isEmpty(tail(tail(_arg)))) {
                                                        pattern_matching_result_4 = 0;
                                                        invoiceeNr_4 = activePatternResult_4;
                                                    }
                                                    else {
                                                        pattern_matching_result_4 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_4 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_4 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_4 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_4 = 1;
                                    }
                                    switch (pattern_matching_result_4) {
                                        case 0: {
                                            return new Page_1(3, invoiceeNr_4);
                                        }
                                        case 1: {
                                            let pattern_matching_result_5, invoiceeNr_5;
                                            if (!isEmpty(_arg)) {
                                                const activePatternResult_5 = Route_$007CInt64$007C_$007C(head(_arg));
                                                if (activePatternResult_5 != null) {
                                                    if (!isEmpty(tail(_arg))) {
                                                        if (head(tail(_arg)) === "Agreements") {
                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                pattern_matching_result_5 = 0;
                                                                invoiceeNr_5 = activePatternResult_5;
                                                            }
                                                            else {
                                                                pattern_matching_result_5 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_5 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_5 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_5 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_5 = 1;
                                            }
                                            switch (pattern_matching_result_5) {
                                                case 0: {
                                                    return new Page_1(4, invoiceeNr_5);
                                                }
                                                case 1: {
                                                    let pattern_matching_result_6, invoiceeNr_6;
                                                    if (!isEmpty(_arg)) {
                                                        const activePatternResult_6 = Route_$007CInt64$007C_$007C(head(_arg));
                                                        if (activePatternResult_6 != null) {
                                                            if (!isEmpty(tail(_arg))) {
                                                                if (head(tail(_arg)) === "CustomerFees") {
                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                        pattern_matching_result_6 = 0;
                                                                        invoiceeNr_6 = activePatternResult_6;
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_6 = 1;
                                                                    }
                                                                }
                                                                else {
                                                                    pattern_matching_result_6 = 1;
                                                                }
                                                            }
                                                            else {
                                                                pattern_matching_result_6 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_6 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_6 = 1;
                                                    }
                                                    switch (pattern_matching_result_6) {
                                                        case 0: {
                                                            return new Page_1(5, invoiceeNr_6);
                                                        }
                                                        case 1: {
                                                            let pattern_matching_result_7, invoiceeNr_7;
                                                            if (!isEmpty(_arg)) {
                                                                const activePatternResult_7 = Route_$007CInt64$007C_$007C(head(_arg));
                                                                if (activePatternResult_7 != null) {
                                                                    if (!isEmpty(tail(_arg))) {
                                                                        if (head(tail(_arg)) === "History") {
                                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                                pattern_matching_result_7 = 0;
                                                                                invoiceeNr_7 = activePatternResult_7;
                                                                            }
                                                                            else {
                                                                                pattern_matching_result_7 = 1;
                                                                            }
                                                                        }
                                                                        else {
                                                                            pattern_matching_result_7 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_7 = 1;
                                                                    }
                                                                }
                                                                else {
                                                                    pattern_matching_result_7 = 1;
                                                                }
                                                            }
                                                            else {
                                                                pattern_matching_result_7 = 1;
                                                            }
                                                            switch (pattern_matching_result_7) {
                                                                case 0: {
                                                                    return new Page_1(6, invoiceeNr_7);
                                                                }
                                                                case 1: {
                                                                    let pattern_matching_result_8, invoiceeNr_8;
                                                                    if (!isEmpty(_arg)) {
                                                                        const activePatternResult_8 = Route_$007CInt64$007C_$007C(head(_arg));
                                                                        if (activePatternResult_8 != null) {
                                                                            if (!isEmpty(tail(_arg))) {
                                                                                if (head(tail(_arg)) === "WholesaleRGU") {
                                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                                        pattern_matching_result_8 = 0;
                                                                                        invoiceeNr_8 = activePatternResult_8;
                                                                                    }
                                                                                    else {
                                                                                        pattern_matching_result_8 = 1;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    pattern_matching_result_8 = 1;
                                                                                }
                                                                            }
                                                                            else {
                                                                                pattern_matching_result_8 = 1;
                                                                            }
                                                                        }
                                                                        else {
                                                                            pattern_matching_result_8 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_8 = 1;
                                                                    }
                                                                    switch (pattern_matching_result_8) {
                                                                        case 0: {
                                                                            return new Page_1(7, invoiceeNr_8);
                                                                        }
                                                                        case 1: {
                                                                            let pattern_matching_result_9, invoiceeNr_9;
                                                                            if (!isEmpty(_arg)) {
                                                                                const activePatternResult_9 = Route_$007CInt64$007C_$007C(head(_arg));
                                                                                if (activePatternResult_9 != null) {
                                                                                    if (!isEmpty(tail(_arg))) {
                                                                                        if (head(tail(_arg)) === "NumberDirectory") {
                                                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                                                pattern_matching_result_9 = 0;
                                                                                                invoiceeNr_9 = activePatternResult_9;
                                                                                            }
                                                                                            else {
                                                                                                pattern_matching_result_9 = 1;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            pattern_matching_result_9 = 1;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        pattern_matching_result_9 = 1;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    pattern_matching_result_9 = 1;
                                                                                }
                                                                            }
                                                                            else {
                                                                                pattern_matching_result_9 = 1;
                                                                            }
                                                                            switch (pattern_matching_result_9) {
                                                                                case 0: {
                                                                                    return new Page_1(8, invoiceeNr_9);
                                                                                }
                                                                                case 1: {
                                                                                    let pattern_matching_result_10, invoiceeNr_10;
                                                                                    if (!isEmpty(_arg)) {
                                                                                        const activePatternResult_10 = Route_$007CInt64$007C_$007C(head(_arg));
                                                                                        if (activePatternResult_10 != null) {
                                                                                            if (!isEmpty(tail(_arg))) {
                                                                                                if (head(tail(_arg)) === "Attributes") {
                                                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                                                        pattern_matching_result_10 = 0;
                                                                                                        invoiceeNr_10 = activePatternResult_10;
                                                                                                    }
                                                                                                    else {
                                                                                                        pattern_matching_result_10 = 1;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    pattern_matching_result_10 = 1;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                pattern_matching_result_10 = 1;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            pattern_matching_result_10 = 1;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        pattern_matching_result_10 = 1;
                                                                                    }
                                                                                    switch (pattern_matching_result_10) {
                                                                                        case 0: {
                                                                                            return new Page_1(9, invoiceeNr_10);
                                                                                        }
                                                                                        case 1: {
                                                                                            let pattern_matching_result_11;
                                                                                            if (isEmpty(_arg)) {
                                                                                                pattern_matching_result_11 = 0;
                                                                                            }
                                                                                            else if (head(_arg) === "") {
                                                                                                if (isEmpty(tail(_arg))) {
                                                                                                    pattern_matching_result_11 = 0;
                                                                                                }
                                                                                                else {
                                                                                                    pattern_matching_result_11 = 1;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                pattern_matching_result_11 = 1;
                                                                                            }
                                                                                            switch (pattern_matching_result_11) {
                                                                                                case 0: {
                                                                                                    return new Page_1(10);
                                                                                                }
                                                                                                case 1: {
                                                                                                    return new Page_1(11);
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

function parseClientSettingUrl(_arg) {
    if (!isEmpty(_arg)) {
        if (isEmpty(tail(_arg))) {
            return new Page_2(1, head(_arg));
        }
        else {
            return new Page_2(2);
        }
    }
    else {
        return new Page_2(0);
    }
}

function parseContractTypeUrl(_arg) {
    let pattern_matching_result, contractTypeCode, contractTypeCode_1, contractTypeCode_2, contractTypeCode_3;
    if (isEmpty(_arg)) {
        pattern_matching_result = 0;
    }
    else if (head(_arg) === "") {
        if (!isEmpty(tail(_arg))) {
            if (head(tail(_arg)) === "General") {
                if (isEmpty(tail(tail(_arg)))) {
                    pattern_matching_result = 1;
                    contractTypeCode = head(_arg);
                }
                else {
                    pattern_matching_result = 5;
                }
            }
            else if (head(tail(_arg)) === "ActivationState") {
                if (isEmpty(tail(tail(_arg)))) {
                    pattern_matching_result = 2;
                    contractTypeCode_1 = head(_arg);
                }
                else {
                    pattern_matching_result = 5;
                }
            }
            else if (head(tail(_arg)) === "Mortgage") {
                if (isEmpty(tail(tail(_arg)))) {
                    pattern_matching_result = 3;
                    contractTypeCode_2 = head(_arg);
                }
                else {
                    pattern_matching_result = 5;
                }
            }
            else if (head(tail(_arg)) === "Subproducts") {
                if (isEmpty(tail(tail(_arg)))) {
                    pattern_matching_result = 4;
                    contractTypeCode_3 = head(_arg);
                }
                else {
                    pattern_matching_result = 5;
                }
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else {
            pattern_matching_result = 0;
        }
    }
    else if (!isEmpty(tail(_arg))) {
        if (head(tail(_arg)) === "General") {
            if (isEmpty(tail(tail(_arg)))) {
                pattern_matching_result = 1;
                contractTypeCode = head(_arg);
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (head(tail(_arg)) === "ActivationState") {
            if (isEmpty(tail(tail(_arg)))) {
                pattern_matching_result = 2;
                contractTypeCode_1 = head(_arg);
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (head(tail(_arg)) === "Mortgage") {
            if (isEmpty(tail(tail(_arg)))) {
                pattern_matching_result = 3;
                contractTypeCode_2 = head(_arg);
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (head(tail(_arg)) === "Subproducts") {
            if (isEmpty(tail(tail(_arg)))) {
                pattern_matching_result = 4;
                contractTypeCode_3 = head(_arg);
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else {
            pattern_matching_result = 5;
        }
    }
    else {
        pattern_matching_result = 1;
        contractTypeCode = head(_arg);
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_3(0);
        }
        case 1: {
            return new Page_3(1, contractTypeCode);
        }
        case 2: {
            return new Page_3(3, contractTypeCode_1);
        }
        case 3: {
            return new Page_3(2, contractTypeCode_2);
        }
        case 4: {
            return new Page_3(4, contractTypeCode_3);
        }
        case 5: {
            return new Page_3(5);
        }
    }
}

function parseContractUrl(_arg) {
    if (!isEmpty(_arg)) {
        if (head(_arg) === "ContractType") {
            return new Page_4(1, parseContractTypeUrl(tail(_arg)));
        }
        else if (head(_arg) === "MortgageSettings") {
            return new Page_4(2);
        }
        else if (head(_arg) === "SubproductDefinitions") {
            return new Page_4(3);
        }
        else if (head(_arg) === "FeeTemplates") {
            return new Page_4(4);
        }
        else {
            return new Page_4(5);
        }
    }
    else {
        return new Page_4(0);
    }
}

function parseCustomerContractUrl(_arg) {
    let pattern_matching_result, invoiceeSubSegments, query;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "RegisterInvoicee") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (head(_arg) === "Invoicee") {
            pattern_matching_result = 1;
            invoiceeSubSegments = tail(_arg);
        }
        else {
            const activePatternResult = Route_$007CQuery$007C_$007C(head(_arg));
            if (activePatternResult != null) {
                if (!isEmpty(activePatternResult)) {
                    if (head(activePatternResult)[0] === "q") {
                        if (isEmpty(tail(activePatternResult))) {
                            if (isEmpty(tail(_arg))) {
                                pattern_matching_result = 2;
                                query = head(activePatternResult)[1];
                            }
                            else {
                                pattern_matching_result = 3;
                            }
                        }
                        else {
                            pattern_matching_result = 3;
                        }
                    }
                    else {
                        pattern_matching_result = 3;
                    }
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else {
                pattern_matching_result = 3;
            }
        }
    }
    else {
        pattern_matching_result = 3;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_5(3);
        }
        case 1: {
            return new Page_5(2, parseInvoiceeUrl(invoiceeSubSegments));
        }
        case 2: {
            return new Page_5(1, query);
        }
        case 3: {
            if (isEmpty(_arg)) {
                return new Page_5(0);
            }
            else {
                return new Page_5(4);
            }
        }
    }
}

function parseDevToolsUrl(_arg) {
    let pattern_matching_result;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "Default") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else if (head(_arg) === "TestData") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_6(0);
        }
        case 1: {
            return new Page_6(1);
        }
        case 2: {
            return new Page_6(2);
        }
    }
}

function parseAdminUrl(_arg) {
    let pattern_matching_result;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "Default") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 4;
            }
        }
        else if (head(_arg) === "SiteWideMessage") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 4;
            }
        }
        else if (head(_arg) === "TelenorErrorReport") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 2;
            }
            else {
                pattern_matching_result = 4;
            }
        }
        else if (head(_arg) === "PayflowPlayground") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 4;
            }
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_7(0);
        }
        case 1: {
            return new Page_7(1);
        }
        case 2: {
            return new Page_7(2);
        }
        case 3: {
            return new Page_7(3);
        }
        case 4: {
            return new Page_7(4);
        }
    }
}

function parseStatusAndWarningsUrl(_arg) {
    let pattern_matching_result;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "Inportations") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "Invoicing") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 2;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "DirectDebit") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "PaymentDemandChain") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 4;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "SubscriptionAndFees") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 5;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "Telecom") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 6;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else if (head(_arg) === "MortgageStatus") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 7;
            }
            else {
                pattern_matching_result = 8;
            }
        }
        else {
            pattern_matching_result = 8;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_8(0);
        }
        case 1: {
            return new Page_8(0);
        }
        case 2: {
            return new Page_8(1);
        }
        case 3: {
            return new Page_8(2);
        }
        case 4: {
            return new Page_8(3);
        }
        case 5: {
            return new Page_8(4);
        }
        case 6: {
            return new Page_8(5);
        }
        case 7: {
            return new Page_8(6);
        }
        case 8: {
            return new Page_8(7);
        }
    }
}

function parseReportsUrl(_arg) {
    if (!isEmpty(_arg)) {
        return new Page_9(1, head(_arg));
    }
    else {
        return new Page_9(0);
    }
}

function parseFileImportUrl(_arg) {
    let pattern_matching_result, bulkImportId;
    if (!isEmpty(_arg)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(_arg));
        if (activePatternResult != null) {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 1;
                bulkImportId = activePatternResult;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_11(1, new Page_10(0));
        }
        case 1: {
            return new Page_11(1, new Page_10(1, bulkImportId));
        }
        case 2: {
            return new Page_11(2);
        }
    }
}

function parseImportUrl(_arg) {
    if (!isEmpty(_arg)) {
        if (head(_arg) === "FileImport") {
            return parseFileImportUrl(tail(_arg));
        }
        else {
            return new Page_11(2);
        }
    }
    else {
        return new Page_11(0);
    }
}

function parseBillingUrl(_arg) {
    let pattern_matching_result, fileName, fileName_1, index, initiationKey;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "ReceiptS1") {
            if (!isEmpty(tail(_arg))) {
                if (isEmpty(tail(tail(_arg)))) {
                    pattern_matching_result = 2;
                    fileName = head(tail(_arg));
                }
                else {
                    pattern_matching_result = 4;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (head(_arg) === "BillingFileContent") {
            if (!isEmpty(tail(_arg))) {
                if (!isEmpty(tail(tail(_arg)))) {
                    if (!isEmpty(tail(tail(tail(_arg))))) {
                        const activePatternResult = Route_$007CInt$007C_$007C(head(tail(tail(tail(_arg)))));
                        if (activePatternResult != null) {
                            if (isEmpty(tail(tail(tail(tail(_arg)))))) {
                                pattern_matching_result = 3;
                                fileName_1 = head(tail(tail(_arg)));
                                index = activePatternResult;
                                initiationKey = head(tail(_arg));
                            }
                            else {
                                pattern_matching_result = 4;
                            }
                        }
                        else {
                            pattern_matching_result = 4;
                        }
                    }
                    else {
                        pattern_matching_result = 4;
                    }
                }
                else {
                    pattern_matching_result = 4;
                }
            }
            else {
                pattern_matching_result = 4;
            }
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_12(0);
        }
        case 1: {
            return new Page_12(1, void 0);
        }
        case 2: {
            return new Page_12(1, fileName);
        }
        case 3: {
            return new Page_12(2, initiationKey, fileName_1, index);
        }
        case 4: {
            return new Page_12(3);
        }
    }
}

function parseNumberInventoryUrl(_arg) {
    let pattern_matching_result, query;
    if (!isEmpty(_arg)) {
        const activePatternResult = Route_$007CQuery$007C_$007C(head(_arg));
        if (activePatternResult != null) {
            if (!isEmpty(activePatternResult)) {
                if (head(activePatternResult)[0] === "q") {
                    if (isEmpty(tail(activePatternResult))) {
                        if (isEmpty(tail(_arg))) {
                            pattern_matching_result = 0;
                            query = head(activePatternResult)[1];
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_13(1, query);
        }
        case 1: {
            return new Page_13(0);
        }
    }
}

export function parseUrl(url) {
    let pattern_matching_result, billingSubSegments, clientSettingsSubSegments, contractSubSegments, customerContractSegments, devToolsSubsegments, adminSubsegments;
    if (!isEmpty(url)) {
        if (head(url) === "Login") {
            pattern_matching_result = 1;
        }
        else if (head(url) === "Billing") {
            pattern_matching_result = 2;
            billingSubSegments = tail(url);
        }
        else if (head(url) === "ClientSettings") {
            pattern_matching_result = 3;
            clientSettingsSubSegments = tail(url);
        }
        else if (head(url) === "EditTemplates") {
            pattern_matching_result = 4;
        }
        else if (head(url) === "Contracts") {
            pattern_matching_result = 5;
            contractSubSegments = tail(url);
        }
        else if (head(url) === "CustomerContract") {
            pattern_matching_result = 6;
            customerContractSegments = tail(url);
        }
        else if (head(url) === "DevTools") {
            pattern_matching_result = 7;
            devToolsSubsegments = tail(url);
        }
        else if (head(url) === "Admin") {
            pattern_matching_result = 8;
            adminSubsegments = tail(url);
        }
        else if (head(url) === "Register") {
            if (!isEmpty(tail(url))) {
                const activePatternResult = Route_$007CQuery$007C_$007C(head(tail(url)));
                if (activePatternResult != null) {
                    if (!isEmpty(activePatternResult)) {
                        if (head(activePatternResult)[0] === "secret") {
                            if (head(activePatternResult)[1] === "demo") {
                                if (isEmpty(tail(activePatternResult))) {
                                    if (isEmpty(tail(tail(url)))) {
                                        pattern_matching_result = 9;
                                    }
                                    else {
                                        pattern_matching_result = 10;
                                    }
                                }
                                else {
                                    pattern_matching_result = 10;
                                }
                            }
                            else {
                                pattern_matching_result = 10;
                            }
                        }
                        else {
                            pattern_matching_result = 10;
                        }
                    }
                    else {
                        pattern_matching_result = 10;
                    }
                }
                else {
                    pattern_matching_result = 10;
                }
            }
            else {
                pattern_matching_result = 10;
            }
        }
        else {
            pattern_matching_result = 10;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page_14(5, new Page_5(0));
        }
        case 1: {
            return new Page_14(0);
        }
        case 2: {
            return new Page_14(1, parseBillingUrl(billingSubSegments));
        }
        case 3: {
            return new Page_14(2, parseClientSettingUrl(clientSettingsSubSegments));
        }
        case 4: {
            return new Page_14(3);
        }
        case 5: {
            return new Page_14(4, parseContractUrl(contractSubSegments));
        }
        case 6: {
            return new Page_14(5, parseCustomerContractUrl(customerContractSegments));
        }
        case 7: {
            return new Page_14(6, parseDevToolsUrl(devToolsSubsegments));
        }
        case 8: {
            return new Page_14(7, parseAdminUrl(adminSubsegments));
        }
        case 9: {
            return new Page_14(8);
        }
        case 10: {
            let pattern_matching_result_1, statusAndWarningsSubsegments, numberInventorySubSegments, reportsSubsegments, segments, importSubsegments;
            if (!isEmpty(url)) {
                if (head(url) === "StatusAndWarnings") {
                    pattern_matching_result_1 = 0;
                    statusAndWarningsSubsegments = tail(url);
                }
                else if (head(url) === "M2M") {
                    if (!isEmpty(tail(url))) {
                        if (head(tail(url)) === "Sim") {
                            pattern_matching_result_1 = 1;
                        }
                        else {
                            pattern_matching_result_1 = 11;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 11;
                    }
                }
                else if (head(url) === "Suspense") {
                    pattern_matching_result_1 = 2;
                }
                else if (head(url) === "MortageValidation") {
                    pattern_matching_result_1 = 3;
                }
                else if (head(url) === "NumberInventory") {
                    pattern_matching_result_1 = 4;
                    numberInventorySubSegments = tail(url);
                }
                else if (head(url) === "Rapporter") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Kontrakt") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Hantera") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Prislistor") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Belåning") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Admin") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Support") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Handling") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Intern") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Internal") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Other") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "Reports") {
                    pattern_matching_result_1 = 5;
                    reportsSubsegments = tail(url);
                }
                else if (head(url) === "i") {
                    pattern_matching_result_1 = 6;
                    segments = tail(url);
                }
                else if (head(url) === "Imports") {
                    pattern_matching_result_1 = 7;
                    importSubsegments = tail(url);
                }
                else if (head(url) === "AdmittanceUsers") {
                    pattern_matching_result_1 = 8;
                }
                else if (head(url) === "ClientDetails") {
                    pattern_matching_result_1 = 9;
                }
                else if (head(url) === "LinkAccount") {
                    pattern_matching_result_1 = 10;
                }
                else {
                    pattern_matching_result_1 = 11;
                }
            }
            else {
                pattern_matching_result_1 = 11;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new Page_14(9, parseStatusAndWarningsUrl(statusAndWarningsSubsegments));
                }
                case 1: {
                    return new Page_14(10);
                }
                case 2: {
                    return new Page_14(11);
                }
                case 3: {
                    return new Page_14(12);
                }
                case 4: {
                    return new Page_14(13, parseNumberInventoryUrl(numberInventorySubSegments));
                }
                case 5: {
                    return new Page_14(14, parseReportsUrl(reportsSubsegments));
                }
                case 6: {
                    const matchValue = ValidatedUrlModule_create(new UrlKind(0, fold((acc, elem) => ((acc + elem) + "/"), "/", segments)));
                    if (matchValue.tag === 1) {
                        return new Page_14(18, new FSharpResult$2(1, matchValue.fields[0]));
                    }
                    else {
                        return new Page_14(18, new FSharpResult$2(0, ValidatedUrlModule_value(matchValue.fields[0])));
                    }
                }
                case 7: {
                    return new Page_14(15, parseImportUrl(importSubsegments));
                }
                case 8: {
                    return new Page_14(16);
                }
                case 9: {
                    return new Page_14(17);
                }
                case 10: {
                    return new Page_14(21);
                }
                case 11: {
                    return new Page_14(19);
                }
            }
        }
    }
}

